import { createFileRoute } from '@tanstack/react-router';
import { requireOrgAdminBeforeLoad } from '../../../lib/org-admin-guard';

export const Route = createFileRoute('/_authenticated/company/skills')({
  beforeLoad: requireOrgAdminBeforeLoad
}).lazy(() => import('./skills.lazy').then((d) => d.Route));
